import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { compareAsc, format } from 'date-fns'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import moment from "moment";
import jwt_decode from 'jwt-decode';
import { attendenace_action } from '../../Redux/Actions/attendance_action';

import { Link } from 'react-router-dom';

import MiniCalendar from './miniCalendar';


function DashboardComp() {
	const dispatch = useDispatch()
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let BASE_URL = process.env.REACT_APP_APP_URL;
	let token = JSON.parse(localStorage.getItem('key'));

	const [user, setUser] = useState();
	const [userbirthday, setUserbirthday] = useState([]);
	const [newslistleft, setNewslistleft] = useState([])
	const [newslist, setNewslist] = useState([])
	const [qbsmoments, setQbsmoments] = useState([]);

	useEffect(() => {
		
		let carouselTest = document.querySelectorAll("carouselTest")
		// carouselTest.click()
	}, [])

	const getUserLeavebalance = () => {
		const response = fetch(SERVER_URL + `api/attendance/leave-balance-list`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				// body: JSON.stringify({
				//     id: email
				// }),
			}).then(res => res.json())
			.then(data => {
				setUserbirthday(data.result)
			});
	}

	const getUserTodaysBirthday = () => {
		const response = fetch(SERVER_URL + `api/employee/birthday`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				}
			}).then(res => res.json())
			.then(data => {
				setUserbirthday(data.result)
			});
	}
	const date = new Date();
	let date_formate = format(date, 'yyyy-MM-dd')
	const userId = localStorage.getItem('userId');
	const state = {
		emp_id: userId,
		date: date_formate
	}


	const getNewsFeedsThree = async () => {
		const response = await fetch(SERVER_URL + `api/news/dashboard-news-feed`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			})
			.then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setNewslist(data?.result)
					setNewslistleft(data?.result)
				}


			});

	}

	const calendar = new MiniCalendar();
	calendar.onDateClick = function (e) {
		 
	};
	function setCalendarContainers() {
		calendar.setCalenderContainer(document.querySelector('#calendar'));
		calendar.setHeaderTextElement(document.querySelector("#headerText"));
	}

	function onPrev() {
		setCalendarContainers();
		calendar.prev();
		alert()
	}

	function onNext() {
		setCalendarContainers();
		calendar.next();
	}

	function onToday() {
		setCalendarContainers();
		calendar.goToToday()
	}

	useEffect(() => {
		setCalendarContainers();
	}, [])

	useEffect(() => {
		const gettoken = localStorage.getItem('key');
		const token_data = jwt_decode(gettoken);
		setUser(token_data.name)
	}, [])

	useEffect(() => {
		getUserTodaysBirthday()
		getSingleQuote()
	}, [])

	useEffect(() => {
		dispatch(attendenace_action(state))
		getNewsFeedsThree()
	}, [])

	useEffect(() => {
		getMoments()
		getRecentJoin()
	}, [])
	const getMoments = async () => {
		const response = await fetch(SERVER_URL + `api/moments`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			})
			.then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setQbsmoments(data.result)
				}
			});

	}


	const [quote, setQuote] = useState('');
	const getSingleQuote = () => {
		const response = fetch(SERVER_URL + `api/quote/single-quote`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				}
			}).then(res => res.json())
			.then(data => {
				setQuote(data.result.description)
			});
	}

	const [recentjoinylist, setRecentjoinylist] = useState([]);
	const getRecentJoin = () => {
		const response = fetch(SERVER_URL + `api/employee/recently-joining`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				}
			}).then(res => res.json())
			.then(data => {
				//setQuote(data.result.description)
				setRecentjoinylist(data.result)
			});
	}
	const [talklist, setTalklist] = useState([])
	const [clientfeedbacklist, setClientfeedbacklist] = useState([])
	useEffect(() => {
		gettalk()
		getClientFeedback()
	}, [])

	const gettalk = async () => {
		const response = await fetch(SERVER_URL + `api/employee/talk/dashboard-feedback-suggestion`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			})
			.then(res => res.json())
			.then(data => {
				if (data.status == true) {
					//setHolidaylist(data.result)
					setTalklist(data.talk)
				}
			});
	}
	const getClientFeedback = async () => {
		const response = await fetch(SERVER_URL + `api/employee/client/dashboard-clientfeedback-suggestion`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			})
			.then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setClientfeedbacklist(data.client)
				}
			});
	}

	let talks = []
	const doSomething = () => {
		if (talklist)
			talks = talklist.map((talk, ind) =>
				<div key={ind} >
					<div className="tips_ttl carouselTest" >
						{talk.title}
						<span className="tips_date">{moment(talk.created_on).format('MMMM Do YYYY')}</span>
					</div>
					<p>{talk.message}</p>
				</div>)
	}
	doSomething()

	let qbsmomentsslide = []
	const get_qbsmoment = () => {
		if (qbsmoments)
			qbsmomentsslide = qbsmoments.map((item, ind) =>
				<div key={ind} >
					<img src={`${SERVER_URL + "moments/" + item?.moment_image}`} />
					<p className="team_ttl">{item.title}</p>
				</div>
			)
	}
	get_qbsmoment()

	let client_feedback = []
	const get_client_feedback = () => {
		if (clientfeedbacklist)
			client_feedback = clientfeedbacklist.map((feedback, ind) =>
				<div key={ind} >
					<div className="tips_ttl carouselTest" >
						{feedback.title}
						<span className="tips_date">{moment(feedback.created_on).format('MMMM Do YYYY')}</span>
					</div>
					<p>{feedback.message}</p>
				</div>)
	}
	get_client_feedback()

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-md-3">
					<div className="dash_ttl">{user ? user : ''}</div>
					<div className="dash_search_wrp search">
						<input type="text" className="" placeholder="Are you looking for something ?" />
						<ul className="results" >
							<li><a href="">Search Result #1</a></li>
							<li><a href="">Search Result #2</a></li>
							<li><a href="">Search Result #3</a></li>
							<li><a href="">Search Result #4</a></li>
						</ul>
						<button className="btn_search"><span className="arrow_right"></span><i className="icon icon-magnifier"></i></button>
					</div>

					<div className="dash_white_box mb20">
						<i className="icon icon-hand dash_hand_icon"></i>
						<div className="dash_white_box_ttl">Who join recently ?</div>
						<div className="dash_image_wrp">
							<div className="dash_image_blk">
								<i className="icon icon-chevron-left"></i>
							</div>
							<div className="dash_image_blk ">
								{
									recentjoinylist?.map((item, ind) => {
										if (item.gender == 1 || item.gender == 2) {
											var img_url = '';
											if (item.gender == 1) {
												var img_url = 'images/m_user.png'
											}
											if (item.gender == 2) {
												var img_url = 'images/f_user.png'
											}
											// if(item.user_image!='' || item.user_image!=null || item.user_image!=undefined){
											// 	var img_url = 'images/'+item.user_image;
											// }

											return <img src={`assets/${img_url}`} />
										}

									})
								}
							</div>
							<div className="dash_image_blk">
								<i className="icon icon-chevron-right"></i>
							</div>
						</div>
						<div className="new_wrp"><i className="icon icon-arrow-down"></i>Are you <span>New</span> ?</div>
						<div className="wp100 text-center"><Link to='/user-directry' className="btn_join">Click Here</Link></div>
					</div>

				</div>
				<div className="col-md-6">
					<div className="dash_slider_wrp">
						<div className="tab-content">
							{
								newslist?.map((item, ind) => {
									return <div key={ind} className={`dash_slider tab-pane ${ind == 0 ? 'active' : ''}`} id={`tab${item.newsID
										}`}>
										<img src={`${SERVER_URL + 'news/' + item.image}`} />
										<div className="slider_ttl"><span className="arrow_right"></span>{item.title}</div>
									</div>
								})
							}
						</div>
						<div className="dash_slider_listing_wrp">
							<ul role="tablist" className="nav nav-tabs">
								{
									newslistleft?.map((item, ind) => {

										return <li key={ind} className="dash_slider_listing_blk">
											<a href={`#tab${item.newsID}`} className={`${ind == 0 ? 'active' : ''}`} data-bs-toggle="tab">
												<div className="das_slider_ttl">{item.title}</div>
												<div className="das_slider_date">{moment(item.createdDate).format('DD/MM/YYYY')}</div>
												<p>{item.remark.substring(0, 65)}...</p>
											</a>
										</li>
									})
								}
							</ul>
							<div className="dash_grey_bg">
								<Link to="/dashboard" className="btn_whitebox">All News <i className="fa fa-angle-double-right"></i></Link>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="dash_white_box1 mb20">
						<div className="dash_white_box_ttl1">LinkedIn </div>
						<span className="dash_linkendin_icon"><i className="fa fa-linkedin"></i></span>
						<div className="dash_linkedin_wrp">
							<div className="dash_linkedin_img">
								<img src="assets/images/linkedin.jpg" />
							</div>
							<div className="dash_linkedin_blk">
								<div className="dash_white_box_linkttl">Palantir Technologies</div>
								<p className="mb07">Palantir Technologies is working to radically change how groups analyze information. The company offers a suite of software applications for integrating, visualizing and analyzing the world's information, supporting many kinds of data including structured, unstructured, relational.</p>
								<p><span>- Founders Fund</span></p>
								<p><span>- RRE Ventures</span></p>
								<p>- Undisclosed Investors</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-3">
					<div className="dash_white_box mb20" style={{ minHeight: "unset" }}>
						<i className="fa fa-lightbulb-o dash_bulb_icon"></i>
						<div className="dash_white_box_ttl">Quote of the day</div>
						<p className='relative'><span className="qoute_left"><i className="fa fa-quote-left"></i></span>{quote}<span className="qoute_down"><i className="fa fa-quote-right"></i></span></p>
						<button className="btn_whitebox">All Quote <i className="fa fa-angle-double-right"></i></button>
					</div>
					<div className="team_wrp mb20" style={{ flex: 1 }}>
						{qbsmomentsslide.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} >
							{qbsmomentsslide}
						</Carousel>}
					</div>
				</div>
				<div className="col-md-3">

					<div className="dash_white_box mb20 mh410 talk_clientfeedback_wrp">
						<i className="icon icon-bubbles dash_bubbles_icon"></i>
						<div className="dash_white_box_ttl">Client Feedback</div>
						<div className="tips_wrp">
							<div className="tips_blk">

								
							{client_feedback.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000}>
								{client_feedback}
								</Carousel>}
							</div>
						</div>
						<div className="dash_white_box_ttl">QBS Connect Talk</div>
						<div className="tips_wrp">
							<div className="tips_blk">
								{talks.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} indicators={false} >
									{talks}
								</Carousel>}

							</div>
						</div>


						<div className="dash_white_box_ttl mt10">Events</div>
						<div className="events_wrp">
							<div className="events_blk">
								<span className="events_date">18/08/2023</span>
								<div className="events_ttl">
								Independence  : This independence let’s revive our true spirit of Patriotism and love for our Nation
									<a href="#" className="dash_arrow float-end"><i className="icon icon-chevron-right"></i></a>
								</div>
							</div>
						</div>
						{/* <div className="dash_birthday_wrp">
							<div className="dash_birthday_blk">
								<i className="icon icon-chevron-left"></i>
							</div>
							<div className="dash_birthday_blk ">
								<img src="assets/images/1.png" />
								<img src="assets/images/2.png" />
								<img src="assets/images/3.png" />
								<img src="assets/images/4.png" />
								<img src="assets/images/5.png" />
								<img src="assets/images/1.png" />
							</div>
							<div className="dash_birthday_blk">
								<i className="icon icon-chevron-right"></i>
							</div>
						</div> */}
					</div>
				</div>
				<div className="col-md-3">
					<div className="calContainer">
							<div className="controls">
								<h2><i className="mr05 icon icon-calendar-full"></i><span id="headerText"></span></h2>
								<div className="buttons">
									<button onClick={onPrev} ><i className="icon icon-chevron-left"></i></button>
									<button onClick={onToday}>today</button>
									<button onClick={onNext}><i className="icon icon-chevron-right"></i></button>
								</div>
							</div>
							<div id="calendar"></div>
						</div>
					<div className="dash_white_box mb20" style={{ minHeight: "unset" }}>

						<i className="fa fa-calendar dash_calendar_icon"></i>
						<div className="dash_white_box_ttl">Today's Birthday !</div>
						<div className="birthday_wrapper mb00">
							<div className="birthday_block pb00">
								{userbirthday?.map((items, index) => {
									{ var userImg = items.img ? SERVER_URL + 'dashboards/' + items.img : BASE_URL + 'assets/images/user_icon.png' }
									return (
										<div key={index} className="birthday-item">
											<img src={userImg} alt="" />
											<div className="employe_name">{items.name}</div>
											<div className="employe_post">{items.role_name}</div>
										</div>
									)

								})}
							</div>
						</div>

						















					</div>




				</div>
				<div className="col-md-3">
					<div className="dash_white_box1 mb20">
						<div className="dash_white_box_ttl1">Tweets </div>
						<span className="dash_linkendin_icon"><i className="fa fa-twitter"></i></span>
						<div className="dash_retweet_wrp">
							<span className="retweet_icon"><i className="fa fa-retweet"></i> </span>
							Business & Decision Retweeted
							<span className="float-end tweetlogo"><i className="fa fa-twitter"></i></span>
						</div>
						<div className="dash_tweet_wrp mb20">
							<div className="dash_tweet_img">
								<img src="assets/images/tweetcomp.jpg" />
							</div>
							<div className="dash_tweet_blk">
								<div className="dash_white_box_tweetttl">ESAIP Ingénieurs <span className="grey_color_text">@groupeesaip</span> </div>
								<p>Pas de repos pour le <span>#BigData. #Tourisme</span> et <span>#Transport</span> sont des
									pionniers dans le domaine.  &#8250; <span>bit.ly/2aY917K</span> &#8249; </p>
									<p>The company offers a suite of software applications for integrating, visualizing and analyzing.</p>
								<img src="assets/images/tweet.jpg" />
							</div>


						</div>
					</div>

				</div>
			</div>
		</div>
	)
}

export default DashboardComp;
